const mutations = {
  addPaginationScan: (state, payload) => {
    state.layananApiScan = {
      limit: payload.limit,
      skip: payload.skip,
      search: payload.search,
    };
  },
  addQrCode: (state, payload) => {
    state.layananApiScan = payload;
  },
  setDataLayanan: (state, payload) => {
    state.dataLayanan = payload;
  },
  chooseAkunEpay: (state, payload) => {
    state.akunEpay = payload;
  },
  dataIdLayananMesin: (state, payload) => {
    state.dataPesanan = {
      idmesin: payload.idmesin,
      idsnap_layanan: payload.idsnap_layanan,
      total: payload.total,
      grandtotal: payload.grandtotal,
      namaMesin: payload.namaMesin,
      namaLayanan: payload.namaLayanan,
      durasiLayanan: payload.durasiLayanan,
      idOutlet: payload.idOutlet,
    };
  },
  dataIdCustomer: (state, payload) => {
    state.dataCustomer = {
      idcustomer: payload.idcustomer,
      id: payload.id,
      idoutlet: payload.idoutlet,
      namaoutlet: payload.namaoutlet,
      namacustomer: payload.namacustomer,
      saldocustomer: payload.saldocustomer,
    };
  },

  customerGlobal: (state, payload) => {
    state.dataGlobalCustomer = payload;
  },
};

export default mutations;
